import CONSTANTS from "core/constants";
import EditableBigCode from "./editableBigCode";
import EditableName from "./editableName";
import EditablePhoneAndEditableAdeli from "./editablePhoneAndEditableAdeli";
import EditablePhoneAndUneditableEmail from "./editablePhoneAndUneditableEmail";
import EditablePhoneNumberAndHsa from "./editablePhoneNumberAndHsa";
import UneditableEmail from "./uneditableEmail";
import UneditableNationalIdAndEmail from "./uneditableNationIdAndEmail";

export const possibleCombinations = {
  [CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS.EDITABLE_NAME]: EditableName,
  [CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS.EDITABLE_PHONE_NUMBER_AND_HSA]:
    EditablePhoneNumberAndHsa,
  [CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS
    .UNEDITABLE_NATIONAL_ID_AND_EMAIL]: UneditableNationalIdAndEmail,
  [CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS.UNEDITABLE_EMAIL]:
    UneditableEmail,
  [CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS
    .EDITABLE_PHONE_AND_EDITABLE_ADELI]: EditablePhoneAndEditableAdeli,
  [CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS
    .EDITABLE_PHONE_AND_UNEDITABLE_EMAIL]: EditablePhoneAndUneditableEmail,
  [CONSTANTS.PSYCHOLOGIST_ROW_COMBINATION_KEYS.EDITABLE_BIG_CODE]:
    EditableBigCode,
};
